import { NgClass, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokLinkDirective } from 'src/app/directive/storyblok-link.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
  selector: 'app-usps',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    NgClass,
    RouterModule,
    DynamicModule,
    StoryblokLinkDirective,
    StoryblokDirective,
    NgOptimizedImage,
  ],
  templateUrl: './usps.component.html',
  styleUrls: ['./usps.component.scss'],
})
export class USPSComponent implements OnChanges {
  components: any;
  constructor(private renderer: Renderer2, private el: ElementRef) {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let entry of this.content) {
      entry.aspect_ratio = entry.aspect_ratio ? entry.aspect_ratio : 126;
      entry.height = 400;
      entry.width = entry.height * (entry.aspect_ratio / 100);
      if (this.style == 'small') {
        entry.width = 128;
        entry.height = 165;
        entry.style = 'contain';
        entry.aspect_ratio = (128 / 165) * 100;
      }
    }
  }

  @Input() _uid!: string;
  @Input() component!: string;
  @Input() title!: string;
  @Input() content!: any[];
  @Input() background!: any;
  @Input() _editable: any;
  @Input() style!: string;
  @Input() colour!: string;
}
